/**
 * 背景動画（About セクション）の再生制御。
 *
 * マークアップ側で autoplay しているので、JS が動かなくても再生される。
 * ここでやるのは次の 2 つだけ。
 * - 画面外に出たら止めて、戻ったら再生する（描画とバッテリーの節約）
 * - 「視差効果を減らす」設定のときは再生せずポスター画像のままにする
 */
const ROOT_MARGIN = '200px';

export const initBackgroundVideo = () => {
  const videos = document.querySelectorAll('.js-bg-video');
  if (!videos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    videos.forEach((video) => {
      video.autoplay = false;
      video.pause();
    });

    return;
  }

  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          target.play().catch(() => {});

          return;
        }

        target.pause();
      });
    },
    { rootMargin: ROOT_MARGIN }
  );

  videos.forEach((video) => observer.observe(video));
};
